module.exports = __webpack_public_path__ + "img/Oxxo_Logo.ddcee93a.svg";